import { SERVICES } from '../lib/site';

/**
 * Ticker de servicios — banda oscura que pausa al hacer hover.
 * SEO-friendly: texto real, no decorativo.
 */
const Marquee = () => {
  const items = [...SERVICES.map((s) => s.title), 'Llave en mano', 'Presupuesto 24h'];
  const row = [...items, ...items];

  return (
    <div className="bg-ink text-paper border-y border-line-dark overflow-hidden py-5" aria-hidden="true">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="ticker-item">
            <span className="font-display font-black uppercase">{item}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
